import { BASE_API } from '../../utils/constantes'
import { getToken } from '../Common/token'

export async function getDocumentosServicioOrion(servicioId) {
    try {
        const url = `${BASE_API}/api-orion/servicio_documento/?servicio=${servicioId}`
        const params = {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }
        const response = await fetch(url, params)
        if (response.status === 200) {
            const result = await response.json()
            return result
        }
        return false
    } catch (error) {
        console.error("Error al obtener documentos:", error)
        return false
    }
}

export async function addDocumentoServicioOrion(servicio, tipoDocumento, archivo) {
    try {
        const url = `${BASE_API}/api-orion/servicio_documento/`
        const params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getToken()}`
            },
            body: JSON.stringify({
                servicio,
                tipo_documento: tipoDocumento,
                url_archivo: archivo
            })
        }
        const response = await fetch(url, params)
        const result = await response.json()
        if (response.status === 200 || response.status === 201) {
            result["status"] = "success"
        } else {
            result["status"] = "error"
        }
        return result
    } catch (error) {
        console.error("Error al agregar documento:", error)
        return { status: "error" }
    }
}

export async function deleteDocumentoServicioOrion(id) {
    try {
        const url = `${BASE_API}/api-orion/servicio_documento/${id}/`
        const params = {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }
        const response = await fetch(url, params)
        if (response.status === 204 || response.status === 200) {
            return { status: "success" }
        }
        return { status: "error" }
    } catch (error) {
        console.error("Error al eliminar documento:", error)
        return { status: "error" }
    }
}
